import { LloydsFormSvg } from 'assets/common';

import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const aboutYou: AppContent['aboutYou'] = {
  aboutYouContent: [
    {
      serviceName: 'Online for Business',
      header: 'About you',
      errorHeading: 'Please correct these fields:',
      notification:
        'As a Full Signatory, we’ll automatically set you up as a Full Access User.',
      firstName: {
        label: 'First name',
        name: 'firstName',
      },
      missingFirstName: 'Enter your first name',
      firstNameError: `Make sure your first name only contains letters, numbers, spaces and these special characters: _@&+-./'() `,
      firstNameMaxTextError:
        'Please ensure that the length of your input is less than 31 characters',
      lastName: {
        label: 'Last name',
        name: 'lastName',
      },
      missingLastName: 'Enter your last name',
      LastNameError: `Make sure your last name only contains letters, numbers, spaces and these special characters: _@&+-./'() `,
      lastNameMaxTextError:
        'Please ensure that the length of your input is less than 31 characters',
      dateOfBirth: {
        label: 'Date of birth',
        name: 'dateOfBirth',
      },
      missingDateOfBirth: 'Enter your date of birth',
      invalidDateOfBirth: `This date of birth doesn't look right. Please check it and try again`,
      minorUserError:
        'You must be 18 or over to register for Online for Business',
      emailAddress: {
        label: 'Email address',
        name: 'emailAddress',
        supportiveText: `We'll use this to send you:`,
        supportiveTextItem1: `your User ID and reference number`,
        supportiveTextItem2: `updates on your registration.`,
      },
      missingEmailAddress: 'Enter your email address',
      emailAddressError: `This email address doesn't look right. Please check and try again`,
      confirmEmailAddress: {
        label: 'Confirm your email address',
        name: 'confirmYourEmailAddress',
      },
      missingConfirmEmailAddress: 'Confirm your email address',
      confirmEmailAddressError: `This email address doesn't look right. Please check and try again`,
      emailAddressMismatchError:
        'These email addresses don’t match. Please check and try again',
      termsAndConditions: {
        heading: 'Terms and conditions',
        imageSrc: LloydsFormSvg,
        imageAlt: 'A small form',
        content1: 'Please read the',
        termsAndConditionsLink: 'Online for Business terms and conditions',
        content2: 'before you continue.',
        content3:
          'They include information on services such as bulk payments and online payment controls.',
      },
      agreeToTermsAndConditions: {
        label: 'I agree to the Online for Business terms and conditions.',
        name: 'agreeToTermsAndConditions',
      },
      agreeToTermsAndConditionsError: `Please read the terms and conditions and accept them if you'd like to continue`,
      termsAndConditionsHref:
        'https://www.lloydsbank.com/assets/assets-business-banking/pdfs/ltsbpcstc.pdf',
      nextBtn: 'Continue',
      nextBtnHref: '/sms-otp',
      previousLink: 'Previous',
      previousHref: '/about-the-business',
      alreadyRegisteredPagePath: '/already-registered',
      mobileNumberMissingPagePath: '/mobile-number-missing',
      technicalErrorPageHref: '/technical-error',
      registrationInProgressPath: '/registration-in-progress',
      noOCISMatchFound: {
        heading: 'We couldn’t find your details',
        content1: 'Check that you’ve:',
        listItem1: 'spelled everything correctly',
        listItem2: 'entered your full name.',
        content2: 'Or call us on',
        contactNo: '0345 072 5555',
        content3: 'for some help.',
      },
    },
  ],
};

export default aboutYou;
